const a=(d,o)=>(d.disableDownload===void 0&&o.disableDownload&&(d.disableDownload=!0),d);export{a as default};
//# sourceMappingURL=videoDataNormalizer.js.map
